import React from 'react';
import ReactDOM from 'react-dom';
import './i18nextConf';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import MessengerUserContextProvider from 'pages/live-chat/MessengerUserContextProvider';


ReactDOM.render(
  <React.StrictMode>
    <Router>
      <MessengerUserContextProvider>
          <App />
      </MessengerUserContextProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
